import axiosInstance from "../../routes/axiosConfig";

const ServiceHome = {
  fetchServiceOrders: async (params = {}) => {
    try {
      const response = await axiosInstance.get("/serviceOrder", { params });
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao buscar ordens de serviço:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  fetchOptionsByType: async (type) => {
    try {
      const response = await axiosInstance.get(`/options/${type}`);
      return response.data;
    } catch (error) {
      console.error(
        `Erro ao buscar opções do tipo ${type}:`,
        error.response?.data || error.message
      );
      throw error;
    }
  },

  fetchAllCompanyAddresses: async () => {
    try {
      const response = await axiosInstance.get("/companyAddress/all");
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao buscar todos os endereços de empresas:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  fetchServiceOrderTotals: async () => {
    try {
      const response = await axiosInstance.get("/serviceOrder/total");
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao buscar totais de ordens de serviço:",
        error.response?.data || error.message
      );
      throw error;
    }
  },

  updateServiceOrder: async (serviceOrderId, serviceOrderData) => {
    try {
      const response = await axiosInstance.put("/serviceOrder", serviceOrderData);
      return response.data;
    } catch (error) {
      console.error(
        "Erro ao atualizar ordem de serviço:",
        error.response?.data || error.message
      );
      throw error;
    }
  },
};

export default ServiceHome;
